import { applyMiddleware, legacy_createStore as createStore } from "redux";
import { rootReducer } from "./reducers";
import thunkMiddleware from "redux-thunk";

const middlewareEnhancer = applyMiddleware(thunkMiddleware);

export const store = createStore(rootReducer, {}, middlewareEnhancer);
